import axios from 'axios';
import Token from '@/utils/Token';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Sanctum SPA: enviar cookies automaticamente em todas as requests
// Necessario para que o cookie httpOnly de sessao e o XSRF-TOKEN sejam enviados
window.axios.defaults.withCredentials = true;

window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if(error.response) {
            if (error.response.status === 401) {
                Token.remove();
                window.location.replace("/login?error=auth");
                return Promise.resolve({});
            } else if(error.response.status === 405) {
                error.message = "Voce nao tem permissao para executar esta operacao.";
            } else if(error.response.status === 419) {
                // 419 = CSRF token mismatch (sessao expirada)
                Token.remove();
                window.location.replace("/login?error=auth");
                return Promise.resolve({});
            }
        }
        return Promise.reject(error);
    },
);
